var _g, _path, _path2, _circle, _circle2, _circle3, _circle4, _g2, _g3, _g4, _g5, _circle5, _g6, _g7, _path3, _path4, _path5, _g8, _circle6, _g9, _g0, _path6, _path7, _path8, _path9, _path0, _g1, _path1, _path10, _circle7, _circle8, _circle9, _g10, _path11, _g11, _g12, _g13, _path12, _g14, _g15, _g16, _path13, _path14, _path15, _path16, _path17, _g17, _path18, _path19, _g18, _path20, _path21, _g19, _path22, _path23, _path24, _path25, _path26, _circle0, _circle1, _circle10, _circle11, _path27, _g20, _g21, _path28, _path29, _path30, _path31, _g22, _g23, _g24, _path32, _path33, _g25, _path34, _path35, _g26, _path36, _path37, _path38, _path39, _g27, _g28, _path40, _g29, _g30, _g31, _g32, _path41, _path42, _g33, _g34, _g35, _g36, _path43, _circle12, _path44, _path45, _g37, _g38, _g39, _g40, _path46, _path47, _path48, _circle13, _circle14, _path49, _g41, _path50, _path51, _path52, _path53, _g42, _g43, _path54, _path55, _path56, _polygon, _path57, _path58, _circle15, _g44, _line, _line2, _g45, _path59, _g46, _g47, _g48, _path60, _g49, _g50, _g51, _path61, _g52, _g53, _g54, _path62, _g55, _g56, _g57, _circle16, _circle17, _circle18, _circle19, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _g68, _g69, _g70, _polygon2, _path63, _g71, _path64;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "900px",
    height: "750px",
    viewBox: "0 0 900 750",
    enableBackground: "new 0 0 900 750",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    display: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    display: "inline",
    fill: "#FFFFFF",
    width: 900,
    height: 750
  }))), /*#__PURE__*/React.createElement("g", {
    id: "background"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 189.7446,
    y1: 154.3755,
    x2: 694.9918,
    y2: 659.6226
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#706AED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#271068"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M442.5,93c52.234,1.791,77.146,8.807,129.5,56c39.772,35.852,48.5,51.5,82,66.5 c24.196,10.834,148,32.5,179.5,133c33.446,106.708-1.341,201.808-84,244.5c-91,47-162.556,6.985-205-11 c-59-25-83.027-35.754-183,14.5C268,643.5,164.5,616,104,540c-57.103-71.732-78.099-204.768-12-286.5 c55.667-68.833,119.5-48,172-74.5C305.473,158.066,355,90,442.5,93z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_2_",
    cx: 604.7705,
    cy: 610.4805,
    r: 136.9545,
    gradientTransform: "matrix(0.9958 0.0914 -0.0466 0.508 31.012 245.0541)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.292,
    style: {
      stopColor: "#FDFDFE",
      stopOpacity: 0.2124
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4342,
    style: {
      stopColor: "#F5F8FB",
      stopOpacity: 0.1697
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5439,
    style: {
      stopColor: "#E8EEF6",
      stopOpacity: 0.1368
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6372,
    style: {
      stopColor: "#D6DFEF",
      stopOpacity: 0.1089
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7198,
    style: {
      stopColor: "#BDCDE6",
      stopOpacity: 0.0841
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7951,
    style: {
      stopColor: "#A0B6DB",
      stopOpacity: 0.0615
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8647,
    style: {
      stopColor: "#7C9BCE",
      stopOpacity: 0.0406
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9299,
    style: {
      stopColor: "#537CBE",
      stopOpacity: 0.021
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9892,
    style: {
      stopColor: "#265AAD",
      stopOpacity: 0.0032
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1D53AA",
      stopOpacity: 0
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_2_)",
    d: "M594.689,540.75c-33.627,0-65.104,9.185-92.082,25.163c12.879,3.754,26.139,9.411,41.893,16.087 c39.397,16.694,103.882,52.355,185.713,19.802C697.055,564.362,648.635,540.75,594.689,540.75z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_3_",
    cx: 766.7002,
    cy: 345.6572,
    r: 34.665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2938,
    style: {
      stopColor: "#FDFDFE",
      stopOpacity: 0.1766
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4368,
    style: {
      stopColor: "#F6F5FA",
      stopOpacity: 0.1408
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5472,
    style: {
      stopColor: "#EAE8F2",
      stopOpacity: 0.1132
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6409,
    style: {
      stopColor: "#D9D6E8",
      stopOpacity: 0.0898
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7241,
    style: {
      stopColor: "#C3BDDA",
      stopOpacity: 0.069
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7998,
    style: {
      stopColor: "#A8A0CA",
      stopOpacity: 0.0501
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8697,
    style: {
      stopColor: "#887CB6",
      stopOpacity: 0.0326
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9348,
    style: {
      stopColor: "#63549F",
      stopOpacity: 0.0163
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9946,
    style: {
      stopColor: "#3A2685",
      stopOpacity: 0.0013
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#362283",
      stopOpacity: 0
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "url(#SVGID_3_)",
    cx: 766.7,
    cy: 345.657,
    r: 34.665
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_4_",
    cx: 107.3335,
    cy: 325.6665,
    r: 34.3335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3207,
    style: {
      stopColor: "#FDFDFF",
      stopOpacity: 0.1698
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4767,
    style: {
      stopColor: "#F6F5FD",
      stopOpacity: 0.1308
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5972,
    style: {
      stopColor: "#E9E8FA",
      stopOpacity: 0.1007
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6995,
    style: {
      stopColor: "#D8D6F6",
      stopOpacity: 0.0751
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7902,
    style: {
      stopColor: "#C1BDF1",
      stopOpacity: 0.0524
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8728,
    style: {
      stopColor: "#A5A0EB",
      stopOpacity: 0.0318
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9475,
    style: {
      stopColor: "#847DE4",
      stopOpacity: 0.0131
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6860DE",
      stopOpacity: 0
    }
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "url(#SVGID_4_)",
    cx: 107.333,
    cy: 325.667,
    r: 34.333
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 91.5415,
    y1: 309.8745,
    x2: 123.1258,
    y2: 341.4588
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE2A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#271068"
    }
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    fill: "url(#SVGID_5_)",
    cx: 107.333,
    cy: 325.667,
    r: 22.333
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 91.5415,
    y1: 309.8745,
    x2: 123.1258,
    y2: 341.4588
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE2A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A482FF"
    }
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    fill: "url(#SVGID_6_)",
    cx: 107.333,
    cy: 325.667,
    r: 22.333
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FDE1A7",
    d: "M99.833,327.5c-3.125,0-5.667-2.542-5.667-5.667s2.542-5.667,5.667-5.667s5.667,2.542,5.667,5.667 S102.958,327.5,99.833,327.5z M99.833,317.167c-2.573,0-4.667,2.093-4.667,4.667s2.093,4.667,4.667,4.667s4.667-2.093,4.667-4.667 S102.407,317.167,99.833,317.167z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DABACC",
    d: "M116.201,340.891c-2.127,0-3.936-0.912-4.96-2.502c-1.804-2.8-0.553-6.829,2.787-8.982 c1.351-0.87,2.862-1.33,4.371-1.33c2.127,0,3.936,0.912,4.96,2.503c1.804,2.8,0.554,6.829-2.787,8.981 C119.221,340.432,117.71,340.891,116.201,340.891z M118.398,329.077c-1.316,0-2.64,0.405-3.829,1.17 c-2.877,1.854-3.994,5.263-2.488,7.599c0.837,1.299,2.338,2.044,4.12,2.044c1.316,0,2.64-0.405,3.829-1.17 c2.877-1.854,3.994-5.263,2.488-7.599C121.681,329.822,120.18,329.077,118.398,329.077z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FDE1A7",
    d: "M92.587,342.579l-0.59-0.808c1.225-0.895,1.928-2.265,1.928-3.761c0-2.573-2.093-4.667-4.667-4.667 c-0.882,0-1.749,0.257-2.507,0.743l-0.539-0.842c0.919-0.589,1.973-0.901,3.046-0.901c3.125,0,5.667,2.542,5.667,5.667 C94.925,339.829,94.073,341.494,92.587,342.579z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FDE1A7",
    d: "M119.37,313.265c-2.757,0-5-2.243-5-5c0-1.298,0.501-2.532,1.412-3.473l0.719,0.695 c-0.729,0.753-1.13,1.74-1.13,2.777c0,2.206,1.794,4,4,4c1.549,0,2.93-0.878,3.602-2.292l0.903,0.43 C123.048,312.141,121.28,313.265,119.37,313.265z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 749.7305,
    y1: 328.687,
    x2: 783.6716,
    y2: 362.6281
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8C6AE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5A55F8"
    }
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    fill: "url(#SVGID_7_)",
    cx: 766.7,
    cy: 345.657,
    r: 24
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#0090B2",
    d: "M788.905,355.274c-0.06,0-0.119-0.01-0.178-0.033c-3.897-1.485-10.881-6.91-17.792-13.821 c-6.911-6.911-12.336-13.895-13.819-17.792c-0.099-0.258,0.031-0.547,0.289-0.645c0.258-0.099,0.547,0.031,0.645,0.29 c1.438,3.775,6.773,10.621,13.593,17.44c6.819,6.819,13.665,12.155,17.44,13.593c0.259,0.098,0.388,0.387,0.289,0.646 C789.297,355.152,789.106,355.274,788.905,355.274z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#8A69E3",
    d: "M790.684,347.055c-0.075,0-0.151-0.017-0.224-0.053c-3.716-1.854-8.999-6.025-14.133-11.159 c-5.024-5.024-9.157-10.233-11.056-13.932c-0.127-0.246-0.029-0.547,0.216-0.673c0.245-0.125,0.548-0.029,0.673,0.216 c1.854,3.612,5.92,8.727,10.874,13.682c5.062,5.062,10.248,9.163,13.873,10.972c0.247,0.123,0.347,0.423,0.224,0.67 C791.044,346.953,790.867,347.055,790.684,347.055z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 534.9268,
    y1: 586.9805,
    x2: 703.2822,
    y2: 586.9805
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#005092"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8C6AE2"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_8_)",
    d: "M601.609,558.918c-24.481,0-47.331,6.976-66.683,19.037c3.097,1.3,6.278,2.648,9.573,4.045 c34.969,14.817,89.7,44.578,158.782,28.322C680.294,579.146,643.316,558.918,601.609,558.918z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 617.7393,
    y1: 588.249,
    x2: 703.2822,
    y2: 588.249
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1AA9E8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#005092"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_9_)",
    d: "M703.282,610.322c-18.223-24.713-45.24-42.534-76.432-48.866c-4.879,0.976-9.365,3.272-9.101,8.294 c0.5,9.5,14.966,10.397,22.25,12c8.334,1.833,20.001,5.583,20.25,11.75c0.182,4.499-5.665,5.165-8.665,5.165 s-7.496-1.416-8.252,1.168c-0.999,3.417,6.299,4.66,5.834,7.167c-0.688,3.715-10.227,3.004-12.131,6.204 C657.256,616.061,679.412,615.939,703.282,610.322z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 534.9268,
    y1: 579.2852,
    x2: 608.0889,
    y2: 579.2852
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#005092"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1AA9E8"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_10_)",
    d: "M584.5,591.5c3-4.167,25.166-4.667,23.5-12.667c-1.435-6.887-27.667-1.666-28.834-9.5 c-0.691-4.643,5.057-7.821,10.617-9.849c-20.005,1.861-38.659,8.375-54.856,18.471c3.097,1.3,6.278,2.648,9.573,4.045 c11.363,4.815,24.816,11.208,40.168,17.087C583.5,596.419,582.999,593.584,584.5,591.5z"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4578BA",
    d: "M345.74,567.416c-2.778,0-5.585-0.218-8.429-0.673c-16.875-2.705-28.453-12.549-34.414-29.261 c-9.344-26.195-1.449-63.03,6.063-71.48c0.183-0.206,0.499-0.224,0.706-0.042c0.207,0.184,0.225,0.5,0.042,0.706 c-6.382,7.18-15.647,43.063-5.868,70.48c5.829,16.342,17.143,25.967,33.63,28.608c2.779,0.445,5.529,0.658,8.248,0.659 c27.929,0.002,52.859-22.457,79.121-46.112c21.896-19.722,44.537-40.116,71.967-51.762c39.336-16.701,74.268-14.594,99.776-13.055 c13.379,0.809,24.933,1.505,33.633-0.638c14.848-3.658,27.53-11.768,39.795-19.611c6.67-4.266,13.567-8.676,20.764-12.348 c25.755-13.142,46.55-15.3,52.979-5.496c7.743,11.809-5.988,22.953-19.269,33.73c-10.757,8.729-21.879,17.756-22.316,27.234 c-0.651,14.149,19.726,19.111,19.932,19.152c0.271,0.054,0.446,0.317,0.393,0.588c-0.055,0.271-0.321,0.448-0.588,0.393 c-0.215-0.043-21.424-5.222-20.734-20.18c0.457-9.926,11.757-19.096,22.685-27.964c13.53-10.98,26.311-21.353,19.063-32.405 c-6.13-9.347-26.419-7.054-51.688,5.838c-7.153,3.649-14.03,8.047-20.681,12.3c-12.333,7.887-25.085,16.042-40.095,19.739 c-8.845,2.18-20.471,1.479-33.932,0.665c-25.404-1.531-60.203-3.633-99.325,12.977c-27.276,11.581-49.854,31.918-71.688,51.585 C399.1,544.831,374.025,567.415,345.74,567.416z"
  }))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    fill: "#4578BA",
    cx: 661.783,
    cy: 441.021,
    r: 2.211
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4578BA",
    d: "M644.731,444.22c-19.521,0-45.385-8.747-59.344-36.16c-20-39.276,12.091-71.718,16.364-74.16 c0.236-0.137,0.544-0.055,0.683,0.186c0.137,0.24,0.054,0.545-0.187,0.682c-4.188,2.394-35.631,34.227-15.97,72.839 c18.502,36.331,58.192,39.387,75.329,32.947c0.257-0.101,0.547,0.034,0.644,0.292c0.098,0.259-0.033,0.547-0.292,0.644 C657.479,443.173,651.484,444.22,644.731,444.22z"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4578BA",
    d: "M750.125,432.375c-0.136,0-0.271-0.055-0.369-0.163c-0.187-0.204-0.172-0.521,0.032-0.706 c4.029-3.674,4.983-12.232,4.118-14.583c-0.096-0.259,0.037-0.547,0.296-0.642c0.255-0.099,0.546,0.037,0.642,0.296 c0.961,2.605,0.01,11.663-4.382,15.667C750.366,432.332,750.245,432.375,750.125,432.375z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 757.9512,
    y1: 354.4058,
    x2: 772.9026,
    y2: 339.4543
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE2A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#745B7F"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_11_)",
    d: "M796.789,369.683c-0.543-1.881-1.337-3.604-2.205-5.269c-1.712-3.249-3.755-6.257-5.896-9.175 c-0.275,0.632-0.571,1.256-0.903,1.867c1.848,2.646,3.565,5.382,4.993,8.23c0.793,1.603,1.5,3.252,1.938,4.911 c0.215,0.825,0.356,1.66,0.341,2.42c-0.011,0.767-0.217,1.399-0.581,1.74c-0.356,0.35-0.981,0.53-1.741,0.521 c-0.751-0.004-1.574-0.164-2.388-0.397c-1.635-0.471-3.258-1.211-4.833-2.036c-3.156-1.665-6.156-3.706-9.068-5.853 c-5.822-4.316-11.254-9.193-16.371-14.359c-2.574-2.57-5.069-5.219-7.459-7.956c-2.401-2.726-4.723-5.522-6.882-8.429 c-2.162-2.9-4.195-5.906-5.865-9.059c-0.825-1.574-1.565-3.196-2.038-4.831c-0.234-0.813-0.394-1.635-0.399-2.387 c-0.01-0.752,0.167-1.37,0.509-1.728c0.78-0.822,2.569-0.679,4.171-0.256c1.66,0.436,3.311,1.142,4.914,1.934 c2.854,1.425,5.589,3.149,8.244,4.99c0.599-0.325,1.21-0.613,1.828-0.883c-2.904-2.153-5.913-4.187-9.156-5.902 c-1.664-0.868-3.386-1.664-5.267-2.207c-0.942-0.266-1.929-0.472-3.005-0.478c-0.538,0-1.104,0.056-1.683,0.228 c-0.289,0.092-0.58,0.206-0.859,0.369c-0.133,0.072-0.284,0.171-0.438,0.292c-0.175,0.131-0.196,0.167-0.303,0.255l-0.012,0.01 l-0.03,0.03c-0.972,0.966-1.234,2.27-1.247,3.324c-0.015,1.086,0.172,2.085,0.419,3.04c0.506,1.906,1.268,3.656,2.104,5.349 c1.689,3.376,3.715,6.516,5.866,9.549c4.323,6.054,9.237,11.627,14.467,16.867c5.273,5.197,10.854,10.092,16.881,14.449 c3.021,2.167,6.166,4.184,9.539,5.878c1.692,0.836,3.441,1.599,5.347,2.105c0.954,0.248,1.952,0.436,3.038,0.421 c1.055-0.013,2.358-0.275,3.324-1.246c0.956-0.981,1.192-2.279,1.186-3.325C797.26,371.612,797.054,370.625,796.789,369.683z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "spaceship"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_12_",
    cx: 761.167,
    cy: 513.459,
    r: 14.5048,
    gradientTransform: "matrix(0.0073 1 -0.9308 0.0068 1233.5479 -251.1783)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#231F20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1018,
    style: {
      stopColor: "#262228"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2637,
    style: {
      stopColor: "#2F2A3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4653,
    style: {
      stopColor: "#3D3865"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6989,
    style: {
      stopColor: "#504A99"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9564,
    style: {
      stopColor: "#6962DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6D66E7"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_12_)",
    d: "M759.917,506.25l11.666-5.583c0,0,2.25,5.166,2.25,12.5c0,7.5-2.916,13.083-2.916,13.083 l-11.084-5.583L759.917,506.25z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 705.498,
    y1: 536.3369,
    x2: 705.498,
    y2: 493.6709
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1AA9E8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B0E1FF"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_13_)",
    d: "M649.485,522.776c-0.902-4.179,17.848-24.275,32.348-27.775s76.646,0.77,77.979,2.937 s1.53,10.262,1.688,15.729c0.101,3.499,0.166,13.334-1.667,13.834s-45.975,8.697-59.5,8.833 C683.75,536.5,650.735,528.567,649.485,522.776z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 740.918,
    y1: 481.4629,
    x2: 757.5612,
    y2: 498.1061
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B0E1FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1AA9E8"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_14_)",
    d: "M756.667,473.666V499h-21.25c0,0-1.88-0.583-1.917-2.167c-0.041-1.749,12-21.583,15.188-22.833 C751.224,473.005,756.667,473.666,756.667,473.666z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 729.6875,
    y1: 513.3975,
    x2: 763.9822,
    y2: 547.6921
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B0E1FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1AA9E8"
    }
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_15_)",
    d: "M711.666,531.418c0,0,15.417-6,21.167-8s23.461-7.191,23.461-7.191s21.933,9.051,23.789,10.607 c1.167,0.979,1.575,3.016,0.75,4c-1.083,1.291-10.771,6.541-12.904,7.098c-1.988,0.519-12.804,0.443-29.513-0.931 C726.424,536.015,710.249,534.835,711.666,531.418z"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#C0EAFB",
    d: "M749.689,538.292c-0.16,0-0.317-0.077-0.414-0.22c-0.154-0.229-0.095-0.539,0.134-0.694 c5.633-3.819,20.159-10.716,27.869-12.808c0.271-0.071,0.541,0.086,0.613,0.352c0.072,0.267-0.085,0.541-0.352,0.613 c-7.627,2.069-21.997,8.893-27.57,12.671C749.884,538.264,749.786,538.292,749.689,538.292z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 657.9043,
    y1: 530.9775,
    x2: 657.9043,
    y2: 509.7705
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6D66E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0436,
    style: {
      stopColor: "#6962DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3011,
    style: {
      stopColor: "#504A99"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5347,
    style: {
      stopColor: "#3D3865"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7363,
    style: {
      stopColor: "#2F2A3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8982,
    style: {
      stopColor: "#262228"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20"
    }
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_16_)",
    d: "M658.695,509.771c-5.744,5.6-9.633,11.049-9.21,13.006c0.563,2.612,7.597,5.657,16.661,8.201 C667.447,517.986,662.356,512.317,658.695,509.771z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 672.5928,
    y1: 492.8936,
    x2: 693.6573,
    y2: 505.0552
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6D66E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0436,
    style: {
      stopColor: "#6962DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3011,
    style: {
      stopColor: "#504A99"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5347,
    style: {
      stopColor: "#3D3865"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7363,
    style: {
      stopColor: "#2F2A3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8982,
    style: {
      stopColor: "#262228"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_17_)",
    d: "M693.166,505.167c2.445-1.706,3.342-7.766,3.664-11.446c-6.495,0.131-11.861,0.523-14.997,1.28 c-4.804,1.159-10.072,4.146-14.94,7.767C672.598,504.585,689.321,507.85,693.166,505.167z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_18_",
    cx: 701.125,
    cy: 510.709,
    r: 7.0295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#231F20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1018,
    style: {
      stopColor: "#262228"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2637,
    style: {
      stopColor: "#2F2A3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4653,
    style: {
      stopColor: "#3D3865"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6989,
    style: {
      stopColor: "#504A99"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9564,
    style: {
      stopColor: "#6962DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6D66E7"
    }
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    fill: "url(#SVGID_18_)",
    cx: 704.417,
    cy: 512.501,
    r: 4
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_19_",
    cx: 714.5215,
    cy: 510.168,
    r: 7.104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#231F20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1018,
    style: {
      stopColor: "#262228"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2637,
    style: {
      stopColor: "#2F2A3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4653,
    style: {
      stopColor: "#3D3865"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6989,
    style: {
      stopColor: "#504A99"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9564,
    style: {
      stopColor: "#6962DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6D66E7"
    }
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    fill: "url(#SVGID_19_)",
    cx: 717.834,
    cy: 511.418,
    r: 3.75
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_20_",
    cx: 727.0625,
    cy: 509.668,
    r: 7.0242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#231F20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1018,
    style: {
      stopColor: "#262228"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2637,
    style: {
      stopColor: "#2F2A3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4653,
    style: {
      stopColor: "#3D3865"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6989,
    style: {
      stopColor: "#504A99"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9564,
    style: {
      stopColor: "#6962DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6D66E7"
    }
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    fill: "url(#SVGID_20_)",
    cx: 730.25,
    cy: 510.668,
    r: 3.417
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#C0EAFB",
    d: "M751.875,497.292c-0.276,0-0.5-0.224-0.5-0.5v-23.337c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5v23.337 C752.375,497.068,752.151,497.292,751.875,497.292z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "dog_x5F_tail"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 656.25,
    y1: 287.5762,
    x2: 702.1689,
    y2: 287.5762
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE2A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#728390"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_21_)",
    d: "M656.25,302.5c3.646-0.033,14.747-0.458,22.75-8.75c10.375-10.75,6.75-31.25,6.75-31.25 s3.757-0.15,5.25,3.125c1.938,4.25-0.625,12,1,12.875c2.71,1.459,3.375-4.875,5.5-3.875s1.838,5.873,1.375,10.25 c-0.438,4.133-3.313,8.026-2.313,9.313c1.313,1.688,4.438-2.563,5.438-0.563s-2.625,5.875-5.813,7.938 c-2.772,1.794-7.563,3.438-7.438,4.438s4.625,1,3.875,3s-6.375,1.25-9.75,1.25s-8.5-0.125-11.25,2.125S656.25,302.5,656.25,302.5z"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E8878E",
    d: "M669.334,283.167c-0.157,0-0.312-0.073-0.409-0.211c-0.159-0.225-0.106-0.537,0.119-0.697 c0.064-0.046,6.423-4.618,6.124-9.394c-0.193-3.081-1.877-4.649-3.826-6.465c-1.266-1.18-2.575-2.399-3.605-4.146 c-4.075-6.91,0.281-12.203,2.305-13.66c0.222-0.161,0.535-0.111,0.697,0.114c0.162,0.224,0.111,0.536-0.113,0.698 c-1.816,1.308-5.723,6.076-2.027,12.34c0.957,1.622,2.212,2.791,3.426,3.922c2.019,1.88,3.925,3.656,4.143,7.134 c0.334,5.333-6.263,10.073-6.544,10.272C669.534,283.137,669.434,283.167,669.334,283.167z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E8878E",
    d: "M661.667,270.333c-0.101,0-0.202-0.03-0.29-0.092c-3.406-2.421-4.353-5.686-4.547-7.998 c-0.274-3.264,0.817-6.264,1.983-7.43c0.195-0.195,0.512-0.195,0.707,0s0.195,0.512,0,0.707c-1.021,1.021-1.934,3.784-1.694,6.639 c0.177,2.102,1.037,5.068,4.131,7.267c0.225,0.16,0.277,0.472,0.117,0.697C661.978,270.26,661.823,270.333,661.667,270.333z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E8878E",
    d: "M700.501,308c-0.015,0-0.028,0-0.043-0.002c-0.274-0.023-0.479-0.265-0.456-0.54 c0.152-1.826,2.412-2.72,6.514-4.342c1.25-0.494,2.682-1.061,4.289-1.743c2.266-0.963,3.714-2.304,4.304-3.985 c0.829-2.362-0.225-4.739-0.716-5.651c-0.131-0.243-0.04-0.546,0.203-0.678c0.242-0.13,0.546-0.04,0.678,0.203 c0.554,1.029,1.739,3.719,0.779,6.457c-0.688,1.958-2.321,3.497-4.857,4.574c-1.615,0.687-3.055,1.256-4.313,1.753 c-3.606,1.426-5.784,2.287-5.885,3.495C700.977,307.803,700.758,308,700.501,308z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "dog_x5F_hose"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 609.4912,
    y1: 267.8467,
    x2: 631.6396,
    y2: 267.8467
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A281FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF57BD"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_22_)",
    d: "M610.259,244.467l0.796,0.06c0.356,0.044,0.763,0.087,1.077,0.146 c0.65,0.11,1.294,0.247,1.921,0.426c1.258,0.35,2.463,0.826,3.601,1.4c2.278,1.15,4.289,2.685,6.013,4.448 c3.443,3.537,5.772,7.977,6.927,12.655c1.128,4.581,1.356,9.311,0.629,14.029c-0.752,4.691-2.427,9.443-5.791,13.595l-8.111-6.953 c1.917-2.068,3.337-5.141,4.022-8.418c0.701-3.282,0.729-6.837,0.089-10.188c-0.608-3.246-2.047-6.329-4.151-8.744 c-1.051-1.203-2.268-2.229-3.58-2.986c-0.655-0.378-1.334-0.69-2.022-0.925c-0.344-0.122-0.69-0.214-1.037-0.295l-0.429-0.092 c-0.179-0.032-0.484-0.062-0.72-0.093L610.259,244.467z"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFA2BA",
    d: "M618.017,258.492c-0.248,0-0.464-0.185-0.495-0.438c-0.034-0.274,0.16-0.524,0.434-0.558 c1.727-0.217,4.825-1.24,6.186-5.663c0.08-0.264,0.362-0.413,0.624-0.331c0.265,0.081,0.412,0.361,0.331,0.625 c-1.524,4.96-5.05,6.115-7.016,6.361C618.059,258.491,618.038,258.492,618.017,258.492z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFA2BA",
    d: "M625.087,269.314c-1.325,0-2.558-0.215-3.435-0.474c-0.265-0.078-0.416-0.356-0.338-0.621 c0.077-0.265,0.353-0.418,0.621-0.338c2.181,0.642,6.818,1.026,8.741-2.121c0.143-0.236,0.449-0.311,0.688-0.166 c0.235,0.144,0.31,0.452,0.166,0.688C630.097,268.63,627.447,269.314,625.087,269.314z"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFA2BA",
    d: "M627.639,280.905c-4.132,0-6.37-2.138-7.236-3.218c-0.173-0.216-0.139-0.53,0.077-0.703 c0.215-0.171,0.529-0.138,0.702,0.077c0.952,1.187,3.779,3.803,9.46,2.476c0.278-0.063,0.538,0.105,0.602,0.373 c0.063,0.269-0.104,0.538-0.373,0.601C629.684,280.787,628.609,280.905,627.639,280.905z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "dog_x5F_right_leg"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 615.8506,
    y1: 357.1143,
    x2: 650.9707,
    y2: 357.1143
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF57BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE6A77"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_23_)",
    d: "M650.971,363.342c-0.478-0.924-0.9-1.895-1.221-2.925c-2.074-6.67-1.334-13.083-1.334-13.083 s-8.917-2.833-16-4.333s-16.565-3.521-16.565-3.521c0.232,6.438,4.316,19.604,12.982,27.854c3.688,3.512,7.029,5.826,9.97,7.417 C642.503,374.747,648.5,370.061,650.971,363.342z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 638.8027,
    y1: 374.2881,
    x2: 660.1553,
    y2: 374.2881
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C5188E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9F36AD"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_24_)",
    d: "M658.583,385.167c2.729-0.667,1.25-9.417,0.417-11.417c-0.707-1.698-5.344-5.206-8.029-10.408 c-2.471,6.719-8.468,11.405-12.168,11.408c6.247,3.378,10.684,3.476,12.78,4.75C653.507,380.67,655.658,385.882,658.583,385.167z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "dog_x5F_right_hand"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 551.0957,
    y1: 303.6694,
    x2: 570.7256,
    y2: 303.6694
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF57BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE6A77"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_25_)",
    d: "M565.833,293.583c-3.919,2.278-6.523,3.547-13.083,3.75c-0.353,0.011-0.715,0.015-1.083,0.016 c1.022,3.382,1.165,9.146-0.571,13.438c5.971,2.471,12.186,3.459,18.152,2.738C572.672,309.736,569.563,297.875,565.833,293.583z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 526.9209,
    y1: 303.5986,
    x2: 552.4219,
    y2: 303.5986
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C5188E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9F36AD"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_26_)",
    d: "M551.667,297.349c-5.239,0-11.842-1.025-14.584-0.933c-4.333,0.146-6.896,1.833-8.771,3.771 c-1.603,1.656-2.021,4.958-0.188,6.125c2.295,1.46,8.042-0.646,11.208-1.063s5.667,3,11.667,5.5 c0.031,0.013,0.063,0.023,0.096,0.037C552.832,306.495,552.689,300.731,551.667,297.349z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "dog_x5F_body"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 574.5957,
    y1: 331.416,
    x2: 667.6711,
    y2: 297.5393
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#05C5DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5860C4"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_27_)",
    d: "M650.375,316.375c8.27-9.514,20.291-6.55,22.6-4.267c-0.132-0.146-0.257-0.299-0.392-0.442 c-9.831-10.414-23.749-13.25-37.75-20.333c-11.99-6.066-24.666-14.5-28.333-18.458c0,0-6.333,8.875-21.306,15.332 c-10.165,4.383-23.444,2.918-23.444,2.918s1.181,11.15,5.75,19.625c6.875,12.75,30.25,26,50.625,32.5 c14.245,4.544,23.884,5.821,34,6.875C649.875,346,641.97,326.045,650.375,316.375z"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#00E2EC",
    d: "M649.844,317.544c-0.021,0-0.041-0.001-0.062-0.004c-33.619-4.118-51.673-29.688-53.835-34.552 c-0.112-0.252,0.002-0.548,0.254-0.66c0.253-0.11,0.548,0.001,0.66,0.254c2.124,4.779,19.888,29.905,53.042,33.966 c0.274,0.033,0.47,0.283,0.436,0.557C650.308,317.358,650.093,317.544,649.844,317.544z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "dog_x5F_left_leg"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 646.5928,
    y1: 338.8716,
    x2: 685.8252,
    y2: 338.8716
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00E2EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0090B2"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_28_)",
    d: "M685.825,354.997c-2.602-7.788-2.25-31.08-12.851-42.888c-2.309-2.284-14.33-5.248-22.6,4.267 c-8.405,9.67-0.5,29.625,1.75,33.75c5.405,8.523,11.4,14.043,16.854,17.814C673.168,367.166,683.317,361.159,685.825,354.997z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 668.9795,
    y1: 368.875,
    x2: 693.0215,
    y2: 368.875
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A281FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF57BD"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_29_)",
    d: "M689.625,382.75c4.212-0.182,3.604-10.628,2.875-15.125c-0.75-4.625-4.748-7.593-6.5-12.125 c-0.061-0.157-0.117-0.332-0.175-0.503c-2.508,6.162-12.657,12.169-16.846,12.943c5.771,3.99,10.935,6.022,14.146,7.561 C684.739,376.273,685.75,382.917,689.625,382.75z"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#00E2EC",
    d: "M679.876,362.595c-0.127,0-0.254-0.048-0.352-0.145c-20.631-20.409-18.735-39.364-18.021-46.5 c0.027-0.275,0.276-0.47,0.547-0.448c0.274,0.027,0.476,0.272,0.447,0.547c-0.7,7.006-2.562,25.617,17.73,45.69 c0.196,0.194,0.198,0.511,0.004,0.707C680.134,362.546,680.005,362.595,679.876,362.595z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "dog_x5F_left_hand"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 591.8818,
    y1: 297.4688,
    x2: 613.3968,
    y2: 318.9837
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00E2EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0090B2"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_30_)",
    d: "M619.375,293.625c-3.416-3.477-11-5.875-17.875-3c-9.217,3.854-17.379,15.907-23.194,22.653 c3.313,0.745,7.847,2.871,9.819,6.534c1.369,2.542,1.864,5.249,2.028,7.265c9.902-1.833,21.176-6.245,27.597-12.452 C626.247,306.411,622.875,297.188,619.375,293.625z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 556.9834,
    y1: 325.0332,
    x2: 590.1533,
    y2: 325.0332
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A281FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF57BD"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_31_)",
    d: "M578.306,313.278c-1.309,1.518-2.499,2.77-3.556,3.597c-6.289,4.922-12.221,8.398-14.75,11 c-2.188,2.25-4.25,5.75-2.125,7.75c2.902,2.732,7.063,0.313,11.75-3.75c3.75-3.25,5.712-3.076,15.679-4.088 c1.557-0.158,3.187-0.402,4.85-0.709c-0.164-2.016-0.659-4.723-2.028-7.265C586.152,316.149,581.619,314.023,578.306,313.278z"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#00E2EC",
    d: "M588.125,320.313c-0.207,0-0.4-0.129-0.473-0.336c-0.09-0.261,0.048-0.546,0.309-0.636 c13.389-4.647,28.842-21.407,30.961-25.928c0.118-0.25,0.417-0.358,0.665-0.24c0.25,0.117,0.358,0.415,0.241,0.665 c-2.232,4.76-17.661,21.631-31.539,26.447C588.234,320.304,588.18,320.313,588.125,320.313z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "dog_x5F_head"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 544.2568,
    y1: 262.8594,
    x2: 563.0039,
    y2: 262.8594
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9F36AD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1071,
    style: {
      stopColor: "#8D3399"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4036,
    style: {
      stopColor: "#602A65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    style: {
      stopColor: "#3F243F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8695,
    style: {
      stopColor: "#2A2028"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_32_)",
    d: "M544.257,265.238c2.118-0.051,11.618-2.801,13.243-5.613s5.5-0.188,5.5-0.188 s0.438,7.688-7.938,7.938S544.257,265.238,544.257,265.238z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#D039A3",
    d: "M550.007,265.863c0.229-0.687,1.556-1.832,3.931-2.676c2.564-0.911,4.688-1.188,8.125-1.25 c-3.094,2.104-1.687,5.241-4.229,5.438C551.917,267.833,550.007,265.863,550.007,265.863z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 563.9902,
    y1: 223.562,
    x2: 575.7983,
    y2: 235.3701
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE2A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#728390"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_33_)",
    d: "M566.834,235.333c-0.333-2.667,0.251-15.583,1.334-15.917s8.832,8.167,8.916,14.667 C573.501,236,566.834,235.333,566.834,235.333z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 548.0566,
    y1: 223.0244,
    x2: 602.6026,
    y2: 277.5704
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE2A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#728390"
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_34_)",
    d: "M530.75,240.375c0.759-1.044,1.875-1,3-1s22.625,0.25,22.625,0.25S564.5,234,570.75,233.25 s14.625,0.125,14.625,0.125s3.625-3.75,6.75-6.5s6.75-6.375,8.125-6s0.371,10.08-1.25,14.875c-1.5,4.438-5.125,8.875-5.125,8.875 s1.375,8.375,4.625,15.5c2.83,6.205,8,12.75,8,12.75s-6.368,10.007-19.25,14.625c-16.563,5.938-25.5,3.625-25.5,3.625 s-0.197-4.375-0.125-8.125c0.088-4.558,0.25-8.375,0.25-8.375s-5.576-0.739-9.875-2.5c-5.188-2.125-7.625-4.063-7.743-6.887 c1.047,0.32,3.998,1.103,8.868,0.137c8.188-1.625,8.625-5.25,8.625-5.25s-5.9,1.763-15.25-2 C536.25,254,527.751,244.5,530.75,240.375z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 530.1396,
    y1: 244.29,
    x2: 540.6689,
    y2: 244.29
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#653271"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1129,
    style: {
      stopColor: "#5B2F65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.496,
    style: {
      stopColor: "#3D263F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8053,
    style: {
      stopColor: "#2A2128"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20"
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_35_)",
    d: "M540.669,239.446c-3.609-0.04-6.523-0.071-6.919-0.071c-1.125,0-2.241-0.044-3,1 c-1.493,2.054-0.135,5.439,2.869,8.831C536.237,247.902,540.308,244.619,540.669,239.446z"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    fill: "#212F66",
    cx: 565.084,
    cy: 240.667,
    r: 1.917
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    fill: "#0090B2",
    cx: 564.553,
    cy: 239.875,
    r: 0.729
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    fill: "#212F66",
    cx: 577.418,
    cy: 244.333,
    r: 2.25
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    fill: "#0090B2",
    cx: 576.5,
    cy: 243.667,
    r: 0.792
  }))), /*#__PURE__*/React.createElement("g", {
    id: "dog_x5F_helmet"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_36_",
    cx: 568.5713,
    cy: 244.4688,
    r: 44.5061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4E40AF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1096,
    style: {
      stopColor: "#5446B2",
      stopOpacity: 0.0438
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    style: {
      stopColor: "#6558B9",
      stopOpacity: 0.1047
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4387,
    style: {
      stopColor: "#8076C6",
      stopOpacity: 0.1755
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6345,
    style: {
      stopColor: "#A69FD7",
      stopOpacity: 0.2538
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8432,
    style: {
      stopColor: "#D6D3ED",
      stopOpacity: 0.3373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.4
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_36_)",
    d: "M592.064,206.676c-20.872-12.975-48.312-6.573-61.286,14.299s-6.573,48.312,14.3,61.287 c20.872,12.975,48.312,6.573,61.286-14.299S612.938,219.651,592.064,206.676z M600.56,264.767 c-10.381,16.701-32.336,21.823-49.036,11.441c-16.7-10.382-21.823-32.336-11.44-49.037c10.381-16.7,32.336-21.823,49.036-11.441 C605.819,226.111,610.942,248.066,600.56,264.767z"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M565.525,210.913l-1.104,0.246l-1.017,0.271c-0.689,0.197-1.371,0.412-2.044,0.643 c-1.051,0.362-2.196-0.197-2.559-1.248c-0.361-1.051,0.197-2.196,1.249-2.558c0.141-0.049,0.298-0.082,0.44-0.098 c0.792-0.086,1.582-0.151,2.371-0.194l1.209-0.042l1.131,0.004c0.832,0.002,1.505,0.68,1.502,1.512 C566.702,210.165,566.198,210.763,565.525,210.913z"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M555.181,214.097l-1.129,0.501l-1.021,0.496c-0.692,0.356-1.376,0.732-2.047,1.13 c-1.338,0.802-2.62,1.699-3.835,2.684c-2.429,1.968-4.581,4.288-6.378,6.869c-0.531,0.767-1.584,0.958-2.351,0.426 c-0.752-0.521-0.947-1.547-0.454-2.31c1.885-2.898,4.183-5.541,6.813-7.813c1.314-1.136,2.711-2.18,4.176-3.121 c0.733-0.468,1.483-0.912,2.246-1.334l1.188-0.622l1.117-0.538c0.995-0.479,2.19-0.061,2.67,0.934s0.062,2.191-0.935,2.67 C555.225,214.077,555.197,214.089,555.181,214.097z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 561.6602,
    y1: 282.8838,
    x2: 609.0771,
    y2: 282.8838
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF57BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE6A77"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_37_)",
    d: "M609.077,275.22c-1.075-0.883-1.962-1.681-2.577-2.345c0,0-0.738-0.936-1.809-2.432 c-10.01,13.947-26.844,20.534-43.031,17.997c0.04,1.577,0.09,2.685,0.09,2.685s0.16,1.503,0.587,3.821 C579.905,297.105,597.908,289.967,609.077,275.22z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M611.71,233.547c-1.324-5.062-3.541-9.881-6.519-14.166c-2.984-4.279-6.72-8.027-10.996-10.994 c-4.262-2.996-9.023-5.252-14.05-6.596c-5.019-1.356-10.276-1.793-15.447-1.323c-10.351,0.925-20.317,5.617-27.545,13.064 c-7.261,7.404-11.801,17.418-12.474,27.755c-0.792,10.323,2.21,20.897,8.343,29.266c6.09,8.397,15.266,14.497,25.372,16.905 c10.104,2.451,21.058,1.136,30.337-3.587c4.65-2.331,8.9-5.486,12.457-9.304c3.567-3.808,6.452-8.261,8.504-13.072 c-1.977,4.843-4.797,9.354-8.323,13.238c-3.518,3.895-7.75,7.145-12.415,9.575c-9.351,4.839-20.443,6.228-30.713,3.798 c-10.272-2.391-19.637-8.534-25.891-17.06c-6.293-8.494-9.428-19.267-8.666-29.83c0.745-10.57,5.438-20.762,12.876-28.266 c7.407-7.55,17.57-12.261,28.079-13.143c10.511-0.945,21.294,2.027,29.837,8.182c4.275,3.066,7.981,6.905,10.916,11.254 C608.319,223.599,610.464,228.466,611.71,233.547z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 601.3359,
    y1: 247.5205,
    x2: 613.0664,
    y2: 247.5205
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#05C5DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0090B2"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_38_)",
    d: "M611.698,233.55c-1.646,0.549-3.227,1.384-4.661,2.531c-6.547,5.234-7.612,14.787-2.377,21.336 c1.408,1.762,3.132,3.124,5.023,4.074C613.443,252.441,613.999,242.642,611.698,233.55z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "hose"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 190.8052,
    y1: 327.4531,
    x2: 215.9482,
    y2: 327.4531
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#05C5DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5860C4"
    }
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_39_)",
    d: "M210.687,298.64c-0.597,0.583-1.308,1.541-1.957,2.561c-0.653,1.028-1.263,2.143-1.821,3.292 c-1.116,2.304-2.025,4.752-2.722,7.241c-1.392,4.984-1.925,10.155-1.484,15.134c0.433,4.984,1.848,9.766,4.135,14.11 c2.279,4.352,5.413,8.271,9.11,11.726l-10.646,10.342c-4.325-4.797-8.05-10.336-10.603-16.453c-2.57-6.102-3.9-12.738-3.894-19.265 c-0.008-6.537,1.25-12.931,3.473-18.877c1.119-2.976,2.473-5.849,4.111-8.603c0.822-1.377,1.713-2.725,2.725-4.048 c1.025-1.316,2.115-2.636,3.7-3.939L210.687,298.64z"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#00E2EC",
    d: "M203.603,311.587c-4.92,0-8.208-3.757-9.135-4.961c-0.168-0.219-0.127-0.533,0.092-0.701 c0.219-0.167,0.532-0.126,0.701,0.092c0.898,1.169,4.208,4.953,9.081,4.54c0.275-0.027,0.517,0.181,0.54,0.456 c0.023,0.275-0.181,0.517-0.456,0.54C204.147,311.576,203.872,311.587,203.603,311.587z"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#00E2EC",
    d: "M196.936,327.294c-2.793,0-5.005-1.053-6.348-1.914c-0.232-0.149-0.3-0.458-0.151-0.691 c0.149-0.233,0.458-0.301,0.691-0.151c2.003,1.285,6.125,3.036,11.233,0.31c0.242-0.13,0.546-0.039,0.676,0.206 c0.13,0.244,0.038,0.546-0.206,0.676C200.685,326.876,198.695,327.294,196.936,327.294z"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#00E2EC",
    d: "M195.226,345.771c-0.394,0-0.763-0.013-1.103-0.032c-0.276-0.016-0.486-0.252-0.47-0.528 s0.253-0.489,0.528-0.47c2.993,0.175,8.498-0.259,11.707-5.097c0.152-0.23,0.462-0.294,0.693-0.14 c0.23,0.152,0.293,0.463,0.14,0.693C203.604,344.896,198.554,345.771,195.226,345.771z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "left_leg"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 533.3164,
    y1: 509.874,
    x2: 604.3594,
    y2: 509.874
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#05C5DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5860C4"
    }
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_40_)",
    d: "M604.334,522.333c-1-3.334-21.667-3.333-24.334-3.667c-1.469-0.184-6.578-16.794-15.875-35.894 c-15.791,2.561-27.625,15.894-30.809,21.106l0.002,0.005c18.42,15.864,31.178,31.186,37.516,32.949 C576.679,538.459,605.334,525.667,604.334,522.333z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 441.166,
    y1: 459.7754,
    x2: 564.125,
    y2: 459.7754
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF57BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE6A77"
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_41_)",
    d: "M564.125,482.772c-7.587-15.585-17.962-32.826-31.428-44.157 c-17.688-14.884-36.03-21.615-50.364-22.948c0,0-19.413,8.26-29.166,17.5c-9.5,9-10.167,16.168-12.001,28.667 c18.833,1.166,35.504,6.009,59.501,18.999c12.305,6.661,23.219,14.927,32.651,23.051l-0.002-0.005 C536.5,498.666,548.334,485.333,564.125,482.772z"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#9F36AD",
    d: "M529.501,483.5c-0.315,0-0.626-0.148-0.82-0.427c-19.836-28.385-67.271-45.246-77.604-46.993 c-0.544-0.093-0.911-0.608-0.819-1.153c0.092-0.544,0.6-0.905,1.153-0.819c10.5,1.775,58.719,18.928,78.908,47.819 c0.316,0.453,0.206,1.076-0.246,1.393C529.898,483.441,529.698,483.5,529.501,483.5z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "left_hand_x5F_2"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 358.2563,
    y1: 278.6743,
    x2: 358.2563,
    y2: 335.3877
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE6A77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C91C91"
    }
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_42_)",
    d: "M361.25,280.5c0,0-14.625-2.75-40.375-1.5c-7.993,0.388-15.035,1.135-21.004,1.995 c-1.537,5.934-3.917,11.529-7.004,16.648c4.633,1.107,8.633,1.607,28.133,10.982s48.381,28.572,58.875,26.625 c12.125-2.25,42.5-13.375,43.75-30.125C424.937,287.547,361.25,280.5,361.25,280.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 403.4951,
    y1: 310.5547,
    x2: 423.645,
    y2: 310.5547
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#05C5DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5860C4"
    }
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_43_)",
    d: "M423.625,305.125c0.298-3.997-2.771-7.448-7.681-10.397c-4.436,3.068-9.892,8.462-11.61,16.022 c-1.529,6.728-0.638,12.567,0.093,15.631C414.283,321.159,422.969,313.919,423.625,305.125z"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#9F36AD",
    d: "M365.833,292.75c-0.077,0-0.156-0.012-0.233-0.037c-25.768-8.427-66.914-6.001-70.004-4.844 c-0.385,0.147-0.819-0.051-0.965-0.439c-0.146-0.388,0.051-0.82,0.439-0.965c3.263-1.224,44.34-3.895,70.996,4.823 c0.394,0.129,0.609,0.552,0.48,0.946C366.443,292.549,366.149,292.75,365.833,292.75z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "left_hand_x5F_1"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: 360.499,
    y1: 295.0586,
    x2: 423.9653,
    y2: 295.0586
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF57BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE6A77"
    }
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_44_)",
    d: "M422.875,298.625c-3.813-9.938-20.089-17.978-30.226-23.001c-2.936-1.455-6.137-2.831-9.408-4.164 c-0.431,3.232-1.828,8.397-6.242,12.707c-5.311,5.184-12.157,6.116-16.501,6.181c3.089,3.812,6.277,7.359,9.501,10.028 c8.13,6.732,24.723,17.044,37.258,18.177c5.387,0.487,10.137-0.642,12.919-4.64C422.17,311.046,425.785,306.209,422.875,298.625z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: 403.5015,
    y1: 305.7275,
    x2: 423.9653,
    y2: 305.7275
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#05C5DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0090B2"
    }
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_45_)",
    d: "M420.177,313.912c1.994-2.866,5.608-7.702,2.698-15.287c-0.777-2.025-2.078-3.97-3.732-5.828 c-4.507,2.314-12.639,8.403-14.809,17.953c-0.583,2.565-0.81,4.998-0.832,7.202c1.28,0.271,2.542,0.49,3.756,0.6 C412.645,319.039,417.395,317.91,420.177,313.912z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: 321.9443,
    y1: 257.147,
    x2: 383.2417,
    y2: 257.147
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00E2EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0090B2"
    }
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_46_)",
    d: "M383.242,271.46c-12.187-4.969-25.353-9.343-29.492-14.96c-4.121-5.592-2.563-15.188-4.375-22 c-1.352-5.081-5.563-11.188-9.75-10.5c-5.095,0.836-5.875,7.75-4.875,13.25s2.25,10-0.875,10.75 c-2.677,0.643-6.151-1.51-7.75-2.125c-1.083-0.417-5.346-0.521-3.875,4.5c1.917,6.542,13.333,11.815,19.875,17.375 c5.168,4.393,11.526,14.147,18.374,22.597c4.344-0.065,11.19-0.997,16.501-6.181C381.414,279.857,382.811,274.692,383.242,271.46z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "body"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: 273.355,
    y1: 431.3379,
    x2: 395.4093,
    y2: 328.9221
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE6A77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF57BD"
    }
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_47_)",
    d: "M443.5,387.25c0,0-16.833-25.917-53.125-52.75c-39.32-29.072-94.609-42.238-99.875-42 c0,0-10.25,13.25-21.5,20.25s-34.5,7.75-34.5,7.75s3.75,31.875,20,70.375c5.235,12.403,10.872,21.46,17.653,33.343 C292,459,323.5,495,365.75,497.25C359.667,463.333,385.5,412,443.5,387.25z"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFA2BA",
    d: "M412.136,406.254c-0.292,0-0.582-0.127-0.779-0.373c-42.761-53.082-94.836-88.645-126.437-102.97 c-0.503-0.228-0.726-0.82-0.498-1.324c0.228-0.502,0.82-0.725,1.324-0.498c31.8,14.416,84.186,50.182,127.168,103.538 c0.346,0.43,0.279,1.06-0.151,1.405C412.578,406.182,412.356,406.254,412.136,406.254z"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFA2BA",
    d: "M365.833,476.778c-0.04,0-0.079-0.002-0.119-0.007c-50.191-5.92-82.86-56.743-84.227-58.904 c-0.295-0.467-0.156-1.084,0.311-1.379c0.467-0.297,1.084-0.156,1.38,0.311c11.396,18.023,43.362,53.338,82.771,57.986 c0.548,0.064,0.94,0.562,0.876,1.11C366.765,476.404,366.333,476.778,365.833,476.778z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: 310.0063,
    y1: 377.042,
    x2: 378.1675,
    y2: 319.848
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C5188E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF57BD"
    }
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_48_)",
    d: "M295.167,354.333c-1.833,9,31.667,39.542,41.333,39.542c9.379,0,43.737-38.777,54.11-59.199 c-0.08-0.059-0.155-0.118-0.235-0.176c-14.4-10.647-30.941-19.159-46.384-25.662C329.796,317.443,297.177,344.467,295.167,354.333z "
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#1AA9E8",
    cx: 334.246,
    cy: 356.944,
    r: 8.753
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1AA9E8",
    cx: 347.154,
    cy: 344.037,
    r: 3.82
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1AA9E8",
    d: "M334.246,376.194c-10.614,0-19.25-8.636-19.25-19.25s8.636-19.25,19.25-19.25s19.25,8.636,19.25,19.25 S344.86,376.194,334.246,376.194z M334.246,339.694c-9.512,0-17.25,7.738-17.25,17.25s7.738,17.25,17.25,17.25 s17.25-7.738,17.25-17.25S343.758,339.694,334.246,339.694z"
  })))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#9F36AD",
    d: "M356.214,338.379c-0.501,0-1.003-0.188-1.392-0.564c-0.793-0.769-0.813-2.035-0.044-2.828l14.227-14.681 c0.77-0.793,2.036-0.812,2.828-0.044c0.793,0.769,0.813,2.035,0.044,2.828l-14.227,14.681 C357.258,338.176,356.736,338.379,356.214,338.379z"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#9F36AD",
    d: "M347.265,330.342c-0.506,0-1.013-0.191-1.402-0.574c-0.788-0.774-0.798-2.041-0.023-2.828l12.221-12.425 c0.774-0.787,2.042-0.797,2.828-0.023c0.788,0.774,0.798,2.041,0.023,2.828l-12.221,12.425 C348.299,330.143,347.782,330.342,347.265,330.342z"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#9F36AD",
    d: "M366.776,345.884c-0.472,0-0.946-0.166-1.327-0.504c-0.826-0.733-0.901-1.998-0.168-2.824l14.119-15.91 c0.735-0.826,1.999-0.9,2.824-0.168c0.826,0.733,0.901,1.998,0.168,2.824l-14.119,15.91 C367.877,345.657,367.328,345.884,366.776,345.884z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "right_leg"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientUnits: "userSpaceOnUse",
    x1: 364.8809,
    y1: 439.6055,
    x2: 560.1338,
    y2: 439.6055
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C91C91"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE6A77"
    }
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_49_)",
    d: "M560.134,404.43L560.134,404.43c-28.154-9.844-63.22-23.57-87.134-22.68 c-20,0.745-29.5,5.5-29.5,5.5c-58,24.75-83.833,76.083-77.75,110C439.922,501.2,461.688,457.557,501,444 c15.513-5.35,34.665-5.966,52.164-5.613c0-0.001-0.001-0.002-0.001-0.003C548.993,420.101,557.667,408.167,560.134,404.43z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_50_",
    gradientUnits: "userSpaceOnUse",
    x1: 443.5,
    y1: 395.3496,
    x2: 498.8877,
    y2: 395.3496
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00E2EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0090B2"
    }
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_50_)",
    d: "M472.75,408.834c20.962-1.823,26.435-17.315,26.126-24.031c-9.375-2.114-18.201-3.339-25.876-3.053 c-20,0.745-29.5,5.5-29.5,5.5C444.417,397.834,453.011,410.551,472.75,408.834z"
  })), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#9F36AD",
    d: "M470.55,400.5c-0.825,0-1.496-0.666-1.5-1.492l-0.092-17.367c-0.004-0.828,0.664-1.503,1.492-1.508 c0.003,0,0.005,0,0.008,0c0.825,0,1.496,0.666,1.5,1.492l0.092,17.367c0.004,0.828-0.664,1.503-1.492,1.508 C470.555,400.5,470.553,400.5,470.55,400.5z"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#9F36AD",
    d: "M481.922,400.484c-0.825,0-1.496-0.667-1.5-1.492l-0.086-16.938c-0.004-0.829,0.664-1.504,1.492-1.508 c0.003,0,0.006,0,0.008,0c0.825,0,1.496,0.667,1.5,1.492l0.086,16.938c0.004,0.829-0.664,1.504-1.492,1.508 C481.927,400.484,481.924,400.484,481.922,400.484z"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#9F36AD",
    d: "M459.429,400.563c-0.804,0-1.469-0.637-1.498-1.446l-0.569-15.97c-0.029-0.828,0.618-1.523,1.445-1.553 c0.821-0.038,1.522,0.617,1.553,1.445l0.569,15.97c0.029,0.828-0.618,1.523-1.445,1.553 C459.465,400.563,459.446,400.563,459.429,400.563z"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFA2BA",
    d: "M376.92,477.423c-3.706,0-7.442-0.208-11.205-0.651c-0.548-0.064-0.94-0.562-0.876-1.11 c0.065-0.549,0.563-0.939,1.11-0.876c39.85,4.703,77.171-17.682,101.866-32.492c8.914-5.346,15.954-9.568,21.337-11.563 c17.564-6.511,43.968-4.986,63.025-2.561c0.548,0.07,0.936,0.57,0.866,1.118s-0.563,0.93-1.118,0.866 c-18.838-2.398-44.896-3.918-62.078,2.451c-5.208,1.931-12.528,6.32-21.004,11.403C446.23,457.57,413.128,477.423,376.92,477.423z "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_51_",
    gradientUnits: "userSpaceOnUse",
    x1: 552.0469,
    y1: 420.0098,
    x2: 622.2031,
    y2: 420.0098
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00E2EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0090B2"
    }
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_51_)",
    d: "M599.5,437.5c4.351-1.826,10.168-5.365,16.75-16.25c4.333-7.166,7.667-20.576,5-20.5 c-5.833,0.167-12.764,12.453-22.25,13.25c-8.094,0.68-22.281-3.772-38.866-9.57l0,0c-2.467,3.737-11.141,15.671-6.971,33.954 c0,0.001,0.001,0.002,0.001,0.003C573.83,438.802,592.189,440.568,599.5,437.5z"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    fill: "#9F36AD",
    cx: 572,
    cy: 426,
    r: 6
  }))), /*#__PURE__*/React.createElement("g", {
    id: "right_hand"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_52_",
    gradientUnits: "userSpaceOnUse",
    x1: 198.7612,
    y1: 405.0107,
    x2: 276.3203,
    y2: 405.0107
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE6A77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C91C91"
    }
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_52_)",
    d: "M266.5,451.5c2.25-21.25,9-32.875,9.75-49.5c0.818-18.142-5.106-70.836-39-78.25 c-6-1.313-12.75,0.063-12.75,0.063C210.833,343,197.667,371,198.833,407c1.286,39.682,24.307,65.857,38,79.5 c0.116,0.115,0.225,0.225,0.34,0.339c4.284-4.033,14.532-10.892,29.542-11.174C265.932,467.629,265.693,459.117,266.5,451.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_53_",
    gradientUnits: "userSpaceOnUse",
    x1: 198.8276,
    y1: 430.2549,
    x2: 220.2461,
    y2: 430.2549
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00E2EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0090B2"
    }
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_53_)",
    d: "M218.75,423.875c-4.232-13.379-14.699-16.905-19.922-17.163c0.003,0.097,0.003,0.191,0.006,0.288 c0.6,18.504,5.927,34.069,12.83,46.798C217.426,449.575,223,437.309,218.75,423.875z"
  })), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#9F36AD",
    d: "M202.52,431.675c-0.649,0-1.247-0.424-1.439-1.077c-0.233-0.795,0.222-1.629,1.017-1.862l9.916-2.911 c0.794-0.23,1.628,0.224,1.862,1.017c0.233,0.795-0.222,1.629-1.017,1.862l-9.916,2.911 C202.802,431.655,202.659,431.675,202.52,431.675z"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#9F36AD",
    d: "M200.734,423.652c-0.649,0-1.247-0.424-1.439-1.077c-0.233-0.795,0.222-1.629,1.017-1.862l9.44-2.771 c0.795-0.231,1.628,0.223,1.862,1.017c0.233,0.795-0.222,1.629-1.017,1.862l-9.44,2.771 C201.016,423.633,200.874,423.652,200.734,423.652z"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#9F36AD",
    d: "M204.946,440.127c-0.624,0-1.206-0.392-1.419-1.015c-0.268-0.784,0.15-1.637,0.934-1.904l9.531-3.259 c0.786-0.271,1.637,0.15,1.905,0.934c0.268,0.784-0.15,1.637-0.934,1.904l-9.531,3.259 C205.271,440.102,205.106,440.127,204.946,440.127z"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFA2BA",
    d: "M243.001,471.667c-0.34,0-0.671-0.173-0.858-0.485c-0.172-0.286-0.399-0.654-0.675-1.103 c-18.498-29.997-23.152-56.096-23.8-72.707c-1.473-37.768,9.622-64.643,16.411-74.568c0.311-0.456,0.935-0.573,1.39-0.261 c0.456,0.312,0.573,0.934,0.261,1.39c-6.649,9.723-17.516,36.115-16.063,73.361c0.639,16.372,5.235,42.108,23.504,71.735 c0.281,0.457,0.513,0.832,0.688,1.123c0.284,0.474,0.131,1.088-0.343,1.372C243.354,471.621,243.176,471.667,243.001,471.667z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_54_",
    gradientUnits: "userSpaceOnUse",
    x1: 237.1733,
    y1: 512.7715,
    x2: 284.501,
    y2: 512.7715
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00E2EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0090B2"
    }
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_54_)",
    d: "M260.688,514.625c2.104,6.695-3.438,13.542-3.813,19.5c-0.424,6.736,7.546,15.971,11.75,15.75 c3.958-0.208,6-4.875,5.875-8.125s-1.625-11,1.25-11.625s2.032,5.135,3.375,7.125c1.125,1.667,3.958,1.583,4.75-0.75 c0.808-2.382,1.125-9.083-0.875-13.25c-2.444-5.093-7-10.625-10.25-18c-2.017-4.577-4.755-16.442-6.035-29.585 c-15.009,0.282-25.257,7.141-29.542,11.174C253.521,503.124,258.639,508.108,260.688,514.625z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "head"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_55_",
    gradientUnits: "userSpaceOnUse",
    x1: 256.2388,
    y1: 279.8066,
    x2: 261.8333,
    y2: 311.5349
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C16846"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2653,
    style: {
      stopColor: "#D27565"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5308,
    style: {
      stopColor: "#DE7F7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7814,
    style: {
      stopColor: "#E58589"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E8878E"
    }
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_55_)",
    d: "M263.625,280.625c1.431,2.25,9.625,11.375,14.25,13.875c-1.375,4.25-7,11-15.875,15.125 c-7.264,3.376-16.313,4.75-16.313,4.75s-3.438-8.375-5.563-18.313c-1.443-6.749-2-13.063-2-13.063s5.813,3.188,13.125,3 C258.453,285.815,263.625,280.625,263.625,280.625z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_56_",
    gradientUnits: "userSpaceOnUse",
    x1: 223.77,
    y1: 284.7759,
    x2: 261.693,
    y2: 252.9547
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E8878E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4BEA3"
    }
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_56_)",
    d: "M264.583,266.083c-2.917-11.667-11.833-23.5-14.25-26.667h-6.917l-24.417,15l-0.75,12.833 c0,0,3.357,4.274,8.732,9.952c-2.097,0.859-3.565,2.851-3.565,5.172c0,3.107,2.63,5.625,5.875,5.625 c2.375,0,4.415-1.351,5.341-3.292c8.8,7.275,20.495,7.174,26.034,3.375C266.483,284.095,267.5,277.75,264.583,266.083z"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    fill: "#212F66",
    cx: 242.5,
    cy: 265.25,
    r: 2
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    fill: "#212F66",
    cx: 256.583,
    cy: 255.667,
    r: 1.833
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_57_",
    gradientUnits: "userSpaceOnUse",
    x1: 249.4819,
    y1: 262.167,
    x2: 261.0449,
    y2: 262.167
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF57BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE6A77"
    }
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_57_)",
    d: "M249.545,256.284c1.424-1.601,11.762,6.861,11.495,8.643c-0.267,1.782-2.915,3.011-4.728,3.323 C254.335,264.687,248.832,257.086,249.545,256.284z"
  })), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#954374",
    d: "M256.719,278.084c-1.167,0-2.269-0.383-3.185-1.107c-0.217-0.171-0.253-0.486-0.082-0.702 c0.171-0.217,0.486-0.253,0.702-0.082c0.738,0.583,1.625,0.892,2.564,0.892c2.292,0,4.156-1.878,4.156-4.188 c0-0.284-0.028-0.569-0.084-0.845c-0.055-0.271,0.12-0.535,0.39-0.589c0.272-0.057,0.535,0.12,0.589,0.39 c0.07,0.342,0.105,0.693,0.105,1.044C261.875,275.757,259.563,278.084,256.719,278.084z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_58_",
    gradientUnits: "userSpaceOnUse",
    x1: 210.4634,
    y1: 253.6152,
    x2: 257.0601,
    y2: 253.6152
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#994574"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#43256F"
    }
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_58_)",
    d: "M255.833,225.75c-2.583-2.417-6.417,0.417-8.75,3s-4.174,5.592-6.333,5.417 c-3.083-0.25-2.018-7.616-5.833-7.167c-5.667,0.667-8.5,13.833-10.333,14.833s-3.37-3.142-6.25-1.333 c-3.583,2.25-2.476,12.904-2.917,15.5c-0.297,1.747-5.433,4.929-4.917,11.25c0.622,7.615,8.124,13.27,12.918,15.148 c0-0.008-0.001-0.016-0.001-0.023c0-2.665,1.938-4.893,4.537-5.473c-0.022-2.727-0.542-5.85-1.204-8.151 c-1.583-5.5-5.207-9.771-5.207-9.771c2.333-0.25,16.791-4.562,26.874-13.395C257.032,238.037,258.553,228.294,255.833,225.75z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "helmet"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_59_",
    cx: 238.7666,
    cy: 264.8916,
    r: 47.0205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#635AD5",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1205,
    style: {
      stopColor: "#6960D7",
      stopOpacity: 0.0482
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2878,
    style: {
      stopColor: "#7A72DB",
      stopOpacity: 0.1151
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4824,
    style: {
      stopColor: "#9690E3",
      stopOpacity: 0.193
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6977,
    style: {
      stopColor: "#BDB9ED",
      stopOpacity: 0.2791
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9273,
    style: {
      stopColor: "#EEEDFA",
      stopOpacity: 0.3709
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.4
    }
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_59_)",
    d: "M238.881,218.156c-17.058,0-31.992,9.088-40.229,22.686c7.762-7.028,18.057-11.311,29.354-11.311 c24.163,0,43.75,19.587,43.75,43.75c0,15.81-8.388,29.659-20.954,37.346c20.184-5.277,35.079-23.633,35.079-45.471 C285.881,239.199,264.838,218.156,238.881,218.156z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_60_",
    gradientUnits: "userSpaceOnUse",
    x1: 191.8809,
    y1: 266.7202,
    x2: 267.7637,
    y2: 266.7202
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00E2EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0090B2"
    }
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_60_)",
    d: "M250.904,305.348c-15.064,0-31.353-5.371-39.57-16.681c-14.833-20.417-5.458-58.042,10.688-67.383 c-17.625,6.778-30.14,23.858-30.14,43.872c0,25.958,21.042,47,47,47c10.893,0,20.913-3.716,28.883-9.936 C262.529,304.233,256.848,305.348,250.904,305.348z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_61_",
    gradientUnits: "userSpaceOnUse",
    x1: 203.9521,
    y1: 296.6313,
    x2: 214.9664,
    y2: 287.3893
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A281FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0945,
    style: {
      stopColor: "#B17AF5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3504,
    style: {
      stopColor: "#D36BDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5934,
    style: {
      stopColor: "#EB60CB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8163,
    style: {
      stopColor: "#FA59C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF57BD"
    }
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_61_)",
    d: "M204.021,282.324c-2.915,0-5.623,0.875-7.887,2.367c4.036,8.817,10.713,16.166,19.026,21.036 c2.008-2.47,3.216-5.617,3.216-9.048C218.377,288.75,211.95,282.324,204.021,282.324z"
  })), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M262.126,234.452l1.004,0.643l1.038,0.72c0.671,0.485,1.33,0.989,1.978,1.513 c0.773,0.625,0.893,1.759,0.267,2.533c-0.625,0.773-1.759,0.893-2.532,0.267c-0.087-0.07-0.174-0.157-0.245-0.239 c-0.488-0.578-0.994-1.145-1.516-1.7l-0.783-0.802l-0.865-0.82c-0.541-0.512-0.563-1.366-0.051-1.906 C260.873,234.183,261.592,234.11,262.126,234.452z"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M271.253,243.104c0.995,1.503,1.915,3.125,2.699,4.774c0.788,1.655,1.458,3.365,2.004,5.112 c1.093,3.494,1.681,7.137,1.757,10.779c0.02,0.933-0.721,1.705-1.654,1.725c-0.915,0.019-1.676-0.698-1.723-1.606 c-0.169-3.326-0.803-6.617-1.886-9.747c-0.541-1.565-1.191-3.09-1.946-4.561c-0.759-1.477-1.603-2.872-2.573-4.248 c-0.637-0.903-0.421-2.151,0.481-2.788s2.151-0.421,2.788,0.481c0.01,0.014,0.019,0.027,0.028,0.041L271.253,243.104z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_62_",
    gradientUnits: "userSpaceOnUse",
    x1: 222.9077,
    y1: 304.5752,
    x2: 299.8711,
    y2: 304.5752
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00E2EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0090B2"
    }
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_62_)",
    d: "M299.871,280.995c-8.251,1.188-14.434,2.589-18.184,3.563 c-7.388,16.274-23.77,27.599-42.807,27.599c-1.71,0-3.397-0.097-5.061-0.275c-4.071,4.447-8.475,10.657-10.913,14.227 c5.102,1.333,10.454,2.048,15.973,2.048C268.204,328.156,292.846,308.122,299.871,280.995z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M222.017,221.272c5.115-2.09,10.634-3.194,16.179-3.352c5.547-0.133,11.129,0.716,16.395,2.523 c10.559,3.588,19.679,11.146,25.322,20.774c5.647,9.629,7.672,21.326,5.622,32.265c-1.017,5.474-3.013,10.754-5.859,15.52 c-2.877,4.745-6.568,8.99-10.897,12.422c8.401-7.171,14.197-17.258,15.999-28.076c0.901-5.404,0.905-10.954-0.062-16.333 c-0.964-5.383-2.892-10.586-5.665-15.293c-2.738-4.728-6.332-8.957-10.532-12.457c-4.206-3.498-9.033-6.235-14.182-8.098 C244.029,217.443,232.393,217.486,222.017,221.272z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "phone"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_63_",
    gradientUnits: "userSpaceOnUse",
    x1: 318.793,
    y1: 235.0996,
    x2: 347.7192,
    y2: 235.0996
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#653271"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1129,
    style: {
      stopColor: "#5B2F65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.496,
    style: {
      stopColor: "#3D263F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8053,
    style: {
      stopColor: "#2A2128"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20"
    }
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_63_)",
    d: "M347.689,251.309c0.13,0.513-0.18,1.034-0.693,1.165l-16.609,4.602 c-0.513,0.13-1.034-0.18-1.165-0.693l-10.4-36.492c-0.13-0.512,0.18-1.034,0.692-1.165l17.609-5.602 c0.512-0.13,1.034,0.18,1.164,0.692L347.689,251.309z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_64_",
    gradientUnits: "userSpaceOnUse",
    x1: 320.4927,
    y1: 221.5747,
    x2: 345.6902,
    y2: 246.7723
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#84DBF1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE2A8"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_64_)",
    points: "343.787,248.675 330.587,252.411 321.44,220.626 335.568,215.909  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "block"
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#C7A0F6",
    d: "M368.543,176.495c0.458,1.592-0.462,3.254-2.054,3.712l-67.243,20.345 c-1.592,0.458-3.254-0.462-3.712-2.054l-5.941-21.663c-0.458-1.592,0.462-3.254,2.055-3.712l67.242-19.845 c1.592-0.458,3.254,0.462,3.712,2.055L368.543,176.495z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#FDE1A7",
    d: "M359.721,155.16c0.442,0,0.837,0.298,0.957,0.713l5.944,21.175c0.152,0.53-0.155,1.085-0.711,1.245 l-67.216,20.337c-0.092,0.026-0.185,0.04-0.278,0.04c-0.442,0-0.836-0.298-0.953-0.701l-5.947-21.687 c-0.1-0.347,0.011-0.625,0.086-0.761c0.075-0.135,0.252-0.377,0.612-0.481l67.229-19.841 C359.535,155.174,359.628,155.161,359.721,155.16 M359.721,153.16c-0.274,0-0.553,0.038-0.83,0.118l-67.242,19.845 c-1.592,0.458-2.512,2.12-2.055,3.712l5.941,21.663c0.378,1.315,1.578,2.172,2.881,2.172c0.274,0,0.554-0.038,0.831-0.118 l67.243-20.345c1.592-0.458,2.512-2.12,2.054-3.712l-5.94-21.163C362.225,154.017,361.024,153.16,359.721,153.16L359.721,153.16z"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    fill: "#FE697A",
    cx: 330.5,
    cy: 227.833,
    r: 3.667
  })), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FDE1A7",
    d: "M330.501,228.583c-0.021,0-0.042-0.001-0.064-0.002c-0.413-0.035-0.719-0.398-0.685-0.811l3.177-37.699 c0.035-0.413,0.401-0.71,0.811-0.685c0.413,0.035,0.719,0.398,0.685,0.811l-3.177,37.699 C331.214,228.288,330.887,228.583,330.501,228.583z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_65_",
    gradientUnits: "userSpaceOnUse",
    x1: 332.605,
    y1: 177.4541,
    x2: 347.1787,
    y2: 177.4541
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#67B4D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C7DFF2"
    }
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "url(#SVGID_65_)",
    x1: 332.605,
    y1: 174.697,
    x2: 347.179,
    y2: 180.21
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_66_",
    gradientUnits: "userSpaceOnUse",
    x1: 317.5522,
    y1: 183.0361,
    x2: 326.2358,
    y2: 183.0361
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#67B4D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C7DFF2"
    }
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "url(#SVGID_66_)",
    x1: 317.552,
    y1: 189.336,
    x2: 326.236,
    y2: 176.737
  })), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "341.561,164.518 333.825,174.357 346.011,178.967  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "339.783,164.352 314.683,172.083 329.746,177.119  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "317.813,187.635 325.052,177.132 313.376,173.229  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M332.854,175.593l-2.255,2.868c-0.145,0.185-0.364,0.287-0.59,0.287c-0.08,0-0.16-0.013-0.238-0.039 l-3.238-1.083l-7.138,10.356l25.471-7.846L332.854,175.593z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "envelopes"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_67_",
    gradientUnits: "userSpaceOnUse",
    x1: 303.1787,
    y1: 410.708,
    x2: 368.5073,
    y2: 410.708
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDE1A7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9A144"
    }
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_67_)",
    d: "M368.486,415.04c0.223,2.961-1.319,4.211-3.249,4.844l-50.92,17.109 c-2.234,0.439-4.403-1.014-4.843-3.248l-6.214-31.539c-0.441-2.234,0.948-4.456,3.184-5.167c0,0,15.493-4.601,25.681-6.664 c9.934-2.012,28.24-5.946,28.24-5.946c2.234-0.439,3.885,0.863,4.448,3.446L368.486,415.04z"
  })), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#C44B5F",
    d: "M339.833,415.083c-0.084,0-0.168-0.014-0.25-0.043l-36.654-12.966c-0.391-0.138-0.595-0.566-0.457-0.957 c0.138-0.39,0.567-0.596,0.957-0.457l36.161,12.791l23.535-28.439c0.263-0.317,0.738-0.362,1.056-0.1 c0.319,0.265,0.364,0.737,0.1,1.057l-23.869,28.843C340.266,414.986,340.053,415.083,339.833,415.083z"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#C44B5F",
    d: "M311.457,437.264c-0.152,0-0.305-0.046-0.438-0.142c-0.336-0.242-0.412-0.711-0.17-1.047l15.376-21.347 c0.242-0.335,0.711-0.412,1.047-0.17c0.336,0.242,0.412,0.711,0.17,1.047l-15.376,21.347 C311.919,437.155,311.69,437.264,311.457,437.264z"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#C44B5F",
    d: "M367.802,418.896c-0.1,0-0.201-0.02-0.298-0.062l-18.803-8.146c-0.38-0.165-0.555-0.606-0.39-0.986 c0.165-0.381,0.605-0.557,0.986-0.391l18.803,8.146c0.38,0.165,0.555,0.606,0.39,0.986 C368.368,418.727,368.092,418.896,367.802,418.896z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_68_",
    gradientUnits: "userSpaceOnUse",
    x1: 467.1709,
    y1: 210.1777,
    x2: 520.8232,
    y2: 210.1777
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDE1A7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9A144"
    }
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_68_)",
    d: "M520.764,214.471c0.344,2.384-0.835,3.479-2.361,4.098l-40.254,13.64 c-1.784,0.479-3.618-0.578-4.098-2.361l-6.761-25.174c-0.479-1.783,0.523-3.657,2.292-4.355c0,0,12.281-4.573,20.409-6.802 c7.926-2.173,20.52-5.363,20.52-5.363c1.784-0.479,3.19,0.485,3.788,2.544L520.764,214.471z"
  })), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D66976",
    d: "M497.546,212.974c-0.045,0-0.09-0.006-0.135-0.019l-30.367-8.475c-0.266-0.074-0.421-0.35-0.347-0.616 c0.073-0.266,0.346-0.425,0.616-0.347l30.018,8.377l15.523-23.344c0.152-0.231,0.462-0.292,0.693-0.14 c0.229,0.153,0.292,0.463,0.139,0.693l-15.725,23.646C497.868,212.893,497.71,212.974,497.546,212.974z"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D66976",
    d: "M475.809,232.478c-0.091,0-0.182-0.024-0.264-0.075c-0.235-0.146-0.307-0.455-0.161-0.689l11.266-18.115 c0.146-0.234,0.456-0.304,0.688-0.161c0.235,0.146,0.307,0.455,0.161,0.689l-11.266,18.115 C476.139,232.394,475.976,232.478,475.809,232.478z"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D66976",
    d: "M520.382,217.52c-0.081,0-0.164-0.02-0.239-0.061l-15.659-8.556c-0.243-0.133-0.332-0.437-0.199-0.679 c0.132-0.242,0.438-0.331,0.678-0.199l15.659,8.556c0.243,0.133,0.332,0.437,0.199,0.679 C520.729,217.426,520.559,217.52,520.382,217.52z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_69_",
    gradientUnits: "userSpaceOnUse",
    x1: 430.8799,
    y1: 332.0342,
    x2: 483.5918,
    y2: 332.0342
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDE1A7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9A144"
    }
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_69_)",
    d: "M483.183,326.798c0.939,2.119,0.132,3.443-1.119,4.414L450.6,356.138 c-1.528,0.908-3.504,0.408-4.412-1.12l-14.834-20.065c-0.91-1.528-0.47-3.525,0.988-4.634c0,0,10.187-7.443,17.139-11.63 c6.778-4.083,16.709-10.773,16.709-10.773c1.527-0.909,3.082-0.383,4.173,1.369L483.183,326.798z"
  })), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D66976",
    d: "M431.074,334.857c-0.275,0-0.5-0.223-0.5-0.499s0.223-0.5,0.499-0.501l29.977-0.069l7.391-26.103 c0.075-0.265,0.356-0.422,0.617-0.345c0.267,0.075,0.421,0.352,0.346,0.617l-7.494,26.466c-0.062,0.215-0.257,0.363-0.48,0.364 L431.074,334.857C431.075,334.857,431.074,334.857,431.074,334.857z"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D66976",
    d: "M448.372,357.034c-0.033,0-0.066-0.003-0.1-0.01c-0.271-0.055-0.445-0.319-0.39-0.589l3.713-18.227 c0.056-0.271,0.323-0.445,0.59-0.39c0.271,0.055,0.445,0.319,0.391,0.589l-3.714,18.227 C448.813,356.871,448.605,357.034,448.372,357.034z"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D66976",
    d: "M483.494,329.761c-0.006,0-0.012,0-0.017,0l-16.463-0.563c-0.275-0.009-0.491-0.241-0.482-0.517 c0.01-0.276,0.284-0.506,0.517-0.482l16.463,0.563c0.275,0.009,0.491,0.241,0.482,0.517 C483.984,329.548,483.763,329.761,483.494,329.761z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_70_",
    gradientUnits: "userSpaceOnUse",
    x1: 113.7393,
    y1: 438.5664,
    x2: 163.9551,
    y2: 438.5664
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDE1A7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9A144"
    }
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_70_)",
    d: "M162.475,423.643c1.974,1.879,1.693,3.68,0.772,5.299l-19.448,39.245 c-1.25,1.675-3.622,2.021-5.297,0.77l-23.15-17.112c-1.677-1.25-2.099-3.618-1.015-5.479c0,0,5.713-10.673,11.378-18.352 c5.523-7.486,13.297-19.228,13.297-19.228c1.25-1.674,3.176-1.805,5.149-0.392L162.475,423.643z"
  })), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D66976",
    d: "M114.778,452.073c-0.302,0-0.587-0.185-0.701-0.483c-0.147-0.388,0.048-0.82,0.435-0.968l30.392-11.541 l-3.711-31.539c-0.049-0.411,0.246-0.784,0.657-0.833c0.407-0.045,0.784,0.245,0.833,0.657l3.78,32.12 c0.041,0.342-0.157,0.667-0.479,0.789l-30.939,11.749C114.957,452.058,114.867,452.073,114.778,452.073z"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D66976",
    d: "M141.556,470.12c-0.234,0-0.444-0.166-0.49-0.404l-4.176-21.472c-0.053-0.271,0.124-0.534,0.395-0.587 c0.269-0.05,0.533,0.125,0.586,0.396l4.176,21.472c0.053,0.271-0.124,0.534-0.395,0.587 C141.62,470.117,141.588,470.12,141.556,470.12z"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D66976",
    d: "M149.289,431.48c-0.21,0-0.406-0.134-0.475-0.344c-0.086-0.263,0.057-0.545,0.319-0.631l14.633-4.803 c0.264-0.089,0.545,0.057,0.631,0.318c0.086,0.263-0.057,0.545-0.319,0.631l-14.633,4.803 C149.393,431.473,149.34,431.48,149.289,431.48z"
  })))), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    fill: "#FE697A",
    cx: 125.75,
    cy: 476.75,
    r: 3.5
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    fill: "#FE697A",
    cx: 292.346,
    cy: 416.128,
    r: 3.5
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    fill: "#FE697A",
    cx: 427.116,
    cy: 347.02,
    r: 3.5
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    fill: "#FE697A",
    cx: 500.912,
    cy: 235.249,
    r: 3.5
  })), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FDE1A7",
    d: "M488.167,186c-0.541,0-0.986-0.432-1-0.976c-0.09-3.7-1.027-6.341-2.864-8.075 c-3.844-3.626-11.577-3.366-21.359-3.035L460.365,174c-3.806,0.112-6.222-0.573-7.642-2.171c-1.932-2.174-1.442-5.442-0.924-8.902 c0.469-3.121,0.952-6.349-0.217-9.026c-3.457-7.923-23.849-7.695-40.758-2.938c-17.523,4.928-31.1,10.283-31.235,10.336 c-0.513,0.202-1.095-0.048-1.298-0.562c-0.204-0.513,0.048-1.094,0.562-1.298c0.136-0.054,13.802-5.444,31.43-10.402 c14.243-4.006,38.547-6.445,43.134,4.063c1.398,3.205,0.848,6.88,0.361,10.123c-0.467,3.114-0.87,5.803,0.44,7.277 c0.982,1.106,2.975,1.595,6.084,1.501l2.573-0.084c10.249-0.347,18.348-0.62,22.799,3.579c2.246,2.119,3.388,5.22,3.492,9.48 c0.013,0.552-0.424,1.011-0.976,1.024C488.183,186,488.175,186,488.167,186z"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FDE1A7",
    d: "M493.836,177.652c-0.406,0-0.74-0.324-0.75-0.732c-0.165-6.789-2.951-9.997-9.617-11.074 c-0.409-0.066-0.688-0.451-0.621-0.86c0.066-0.409,0.46-0.686,0.859-0.621c7.342,1.186,10.697,5.046,10.879,12.518 c0.01,0.414-0.317,0.758-0.731,0.768C493.848,177.652,493.842,177.652,493.836,177.652z"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FDE1A7",
    d: "M384.605,150.706c-0.236,0-0.469-0.111-0.615-0.32c-0.238-0.339-0.155-0.807,0.184-1.044 c2.166-1.517,13.742-7.533,26.71-7.01c0.414,0.017,0.736,0.366,0.72,0.779c-0.016,0.414-0.372,0.745-0.779,0.72 c-12.57-0.508-23.707,5.281-25.79,6.74C384.904,150.662,384.754,150.706,384.605,150.706z"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FDE1A7",
    d: "M410.729,168.581c-0.094,0-0.19-0.018-0.284-0.056c-2.593-1.061-9.934-0.946-12.301-0.82 c-0.438,0.011-0.767-0.297-0.789-0.709c-0.021-0.414,0.296-0.767,0.709-0.789c0.096-0.004,9.554-0.458,12.949,0.93 c0.383,0.157,0.567,0.595,0.41,0.979C411.305,168.405,411.025,168.581,410.729,168.581z"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FDE1A7",
    d: "M479.918,307c-0.041,0-0.083-0.002-0.125-0.008c-0.548-0.068-0.937-0.568-0.868-1.116 c0.733-5.87,6.902-8.584,12.867-11.209c6.73-2.961,13.087-5.758,13.208-12.518c0.086-4.756-3.874-7.195-8.458-10.019 c-4.522-2.786-9.649-5.943-10.368-12.012c-0.852-7.19,4.434-13.184,8.68-18c2.323-2.634,4.518-5.123,5.098-7.145 c0.152-0.53,0.706-0.837,1.236-0.686c0.531,0.152,0.838,0.706,0.686,1.237c-0.704,2.456-2.936,4.986-5.52,7.917 c-4.19,4.752-8.94,10.138-8.193,16.441c0.605,5.108,4.892,7.749,9.431,10.544c4.678,2.882,9.515,5.861,9.409,11.758 c-0.145,8.039-7.72,11.372-14.402,14.313c-5.706,2.51-11.096,4.882-11.688,9.626C480.846,306.63,480.415,307,479.918,307z"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FDE1A7",
    d: "M474.501,269.875c-0.237,0-0.471-0.112-0.616-0.321c-5.477-7.858-2.705-15.303-0.475-18.142 c0.257-0.326,0.728-0.383,1.053-0.126c0.326,0.256,0.383,0.728,0.127,1.053c-0.058,0.073-5.691,7.438,0.525,16.358 c0.237,0.34,0.153,0.807-0.187,1.044C474.798,269.832,474.648,269.875,474.501,269.875z"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FDE1A7",
    d: "M375.751,402.375c-0.331,0-0.655-0.164-0.846-0.465c-0.295-0.466-0.157-1.084,0.309-1.38 c2.891-1.833,7.973-2.329,13.858-2.904c4.95-0.483,10.56-1.031,15.094-2.522c7.402-2.434,15.539-7.685,16.175-15.125 c0.416-4.857-1.866-7.178-4.281-9.634c-2.037-2.071-4.143-4.212-4.31-7.798c-0.433-9.306,14.321-16.15,14.95-16.437 c0.5-0.229,1.095-0.008,1.325,0.495c0.229,0.502,0.008,1.095-0.495,1.325c-4.896,2.235-14.079,8.147-13.782,14.524 c0.131,2.822,1.802,4.521,3.737,6.489c2.504,2.546,5.342,5.432,4.849,11.206c-0.72,8.412-9.534,14.223-17.543,16.855 c-4.744,1.56-10.471,2.119-15.524,2.612c-5.396,0.527-10.494,1.025-12.981,2.604C376.12,402.325,375.934,402.375,375.751,402.375z "
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FDE1A7",
    d: "M404.501,361.375c-0.038,0-0.075-0.002-0.113-0.006c-0.549-0.062-0.943-0.557-0.882-1.105 c1.277-11.364,9.448-15.93,12.489-16.73c0.534-0.142,1.082,0.179,1.222,0.713c0.14,0.534-0.179,1.081-0.713,1.222 c-2.492,0.656-9.865,4.823-11.011,15.02C405.437,360.998,405.003,361.375,404.501,361.375z"
  }))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FDE1A7",
    d: "M291.142,417.263c-2.832,0-9.929-1.297-25.389-10.145c-2.03-1.162-4.09-2.36-6.181-3.576 c-20.645-12.006-44.042-25.606-70.903-23.296c-19.896,1.718-29.342,13.438-32.446,17.29c-0.304,0.376-0.544,0.675-0.726,0.878 c-0.367,0.413-0.999,0.451-1.412,0.083c-0.413-0.366-0.45-0.999-0.083-1.411c0.166-0.187,0.386-0.46,0.664-0.805 c3.236-4.017,13.086-16.236,33.832-18.027c27.485-2.384,51.178,11.404,72.081,23.56c2.086,1.213,4.142,2.409,6.168,3.568 c19.708,11.278,25.224,9.814,25.277,9.8c0.514-0.157,1.077,0.119,1.251,0.629c0.174,0.509-0.069,1.059-0.571,1.251 C292.557,417.118,292.087,417.263,291.142,417.263z"
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FDE1A7",
    d: "M151.083,384c-0.165,0-0.33-0.054-0.468-0.164c-0.323-0.259-0.375-0.731-0.117-1.055 c2.737-3.422,10.67-11.256,25.231-10.029c0.413,0.035,0.719,0.397,0.685,0.81c-0.035,0.413-0.405,0.718-0.81,0.685 c-13.831-1.159-21.347,6.237-23.935,9.471C151.521,383.903,151.303,384,151.083,384z"
  }))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FDE1A7",
    d: "M123.249,518.25c-0.521,0-0.96-0.403-0.997-0.931c-1.289-18.555,0.871-34.896,2.535-40.839 c0.149-0.532,0.702-0.843,1.232-0.693c0.532,0.148,0.842,0.701,0.693,1.232c-1.627,5.813-3.736,21.857-2.465,40.161 c0.038,0.551-0.377,1.028-0.928,1.067C123.296,518.249,123.272,518.25,123.249,518.25z"
  }))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FDE1A7",
    d: "M169.656,583.066c-0.129,0-0.261-0.025-0.388-0.078c-0.328-0.139-8.039-3.449-8.906-9.001 c-0.569-3.641,1.035-5.97,2.586-8.222c0.921-1.337,1.874-2.719,2.435-4.44c2.14-6.559-2.426-10.162-4.366-10.996 c-0.507-0.219-0.741-0.807-0.523-1.314c0.217-0.507,0.806-0.739,1.314-0.523c2.406,1.036,8.081,5.472,5.477,13.455 c-0.651,1.996-1.734,3.567-2.689,4.954c-1.511,2.192-2.704,3.925-2.258,6.778c0.696,4.449,7.639,7.437,7.708,7.467 c0.508,0.215,0.747,0.802,0.532,1.31C170.416,582.837,170.045,583.066,169.656,583.066z"
  }))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FDE1A7",
    d: "M174.371,568.632c-0.18,0-0.36-0.064-0.503-0.194c-0.307-0.277-0.331-0.752-0.053-1.059 c2.481-2.743,2.676-5.748,2.402-7.785c-0.41-3.051-1.986-5.312-2.974-5.942c-0.349-0.223-0.452-0.687-0.229-1.035 c0.223-0.35,0.687-0.452,1.036-0.229c1.438,0.917,3.208,3.685,3.654,7.006c0.316,2.353,0.091,5.822-2.776,8.991 C174.779,568.549,174.575,568.632,174.371,568.632z"
  }))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FE697A",
    points: "370.579,163.507 376.816,153.271 381.754,167.841  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_71_",
    gradientUnits: "userSpaceOnUse",
    x1: 97.0674,
    y1: 551.4297,
    x2: 148.0186,
    y2: 551.4297
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDE1A7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9A144"
    }
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_71_)",
    d: "M142.827,527.515l-33.987-6.188c-3.315-0.333-5.52,1.136-5.864,3.986c0,0-0.524,5.079-1.231,11.786 c0.747,0.976,1.497,1.946,2.256,2.9c12.84,16.13,27.624,30.066,43.831,41.578l-0.466-48.282 C147.359,530.737,146.463,528.402,142.827,527.515z"
  })), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D66976",
    d: "M129.19,549.903c-0.235,0-0.471-0.082-0.661-0.25c-0.414-0.366-0.454-0.998-0.088-1.412l17.092-19.359 c0.365-0.413,0.997-0.453,1.411-0.088c0.414,0.366,0.454,0.998,0.088,1.412l-17.092,19.359 C129.743,549.789,129.467,549.903,129.19,549.903z"
  }))), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#D66976",
    d: "M131.655,561.042l-25.261-39.851c-0.296-0.467-0.913-0.605-1.38-0.31s-0.605,0.914-0.31,1.38l24.887,39.261 l-2.503,3.263c0.493,0.453,0.981,0.912,1.478,1.359l3.038-3.959C131.859,561.853,131.879,561.396,131.655,561.042z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpace);
export default __webpack_public_path__ + "static/media/space.7ea3fdd06a771fd135f2ec7ef5107408.svg";
export { ForwardRef as ReactComponent };